import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [authed, setAuthed] = useState(!!localStorage.getItem("app_token"));

  useEffect(() => {
    const t = localStorage.getItem("app_token");
    if (t) {
      api
        .me()
        .then(() => setAuthed(true))
        .catch(() => {
          localStorage.removeItem("app_token");
          setAuthed(false);
        });
    }
  }, []);

  const login = async (password) => {
    const { data } = await api.login(password);
    localStorage.setItem("app_token", data.token);
    setAuthed(true);
  };

  const logout = () => {
    localStorage.removeItem("app_token");
    setAuthed(false);
  };

  return (
    <AuthCtx.Provider value={{ authed, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
